/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/*
 * A React component for Audio Volume Off Icon.
 *
 * @author Ramani Govindaraju
 */

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const NavAudioOff = props => (
  <SvgIcon viewBox="0 0 17 16" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0-1h18v18H0z" />
      <path
        fill="#252525"
        d="M3.673 11H1.5A1.5 1.5 0 0 1 0 9.5v-3A1.5 1.5 0 0 1 1.5 5h2.084L7.72.876A.75.75
        0 0 1 9 1.407V14.59a.75.75 0 0 1-1.285.525L3.673 11z"
      />
      <path
        fill="#252525"
        fillRule="nonzero"
        d="M14 6.869l1.634-1.635a.8.8 0 1 1 1.132 1.132L15.13 8l1.635 1.634a.8.8 0 1
        1-1.132 1.132L14 9.13l-1.634 1.635a.8.8 0 1 1-1.132-1.132L12.87 8l-1.635-1.634a.8.8
        0 1 1 1.132-1.132L14 6.87z"
      />
    </g>
  </SvgIcon>
);

export default NavAudioOff;



// WEBPACK FOOTER //
// ./src/js/icons/NavAudioOff.jsx